import { Basket } from './basket';

export class Order {
    id:number;
    name:string;
    address_line_1:string;
    address_line_2:string;
    town:string;
    county:string;
    postcode:string;
    intent_id:string;
    sub_total:number;
    tax: number;
    amount:number;
    currency:string;
    status:string;
    basket: Basket;
    created_at:string;
    updated_at:string;
    products: any;
    constructor(order?) {
        if (order) {
            this.id = order.id;
            this.name = order.name;
            this.address_line_1 = order.address_line_1;
            this.address_line_2 = order.address_line_2;
            this.town = order.town;
            this.county = order.county;
            this.postcode = order.postcode;
            this.intent_id = order.intent_id;
            this.amount = order.amount;
            this.currency = order.currency;
            this.status = order.status;
            this.basket = order.basket;
            this.amount = order.amount;
            this.sub_total = order.sub_total;
            this.tax = order.tax;
            this.created_at = order.created_at;
            this.updated_at = order.updated_at;
            this.products = order.products || [];
        }
    }
}
